import { Button, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@material-ui/core';
import React from 'react';
import { countryNames } from '../templates/constants';
import { InfoDot } from './info-dot';
const COUNTRY_OPTIONS = Object.entries(countryNames).map(([code, name]) => ({
    code,
    label: `${name} (${code})`
}));
export const CountryAllowListSection = ({ label, info, onChange, value }) => {
    const update = (index, code) => {
        onChange(value.map((c, i) => (i === index ? code : c)));
    };
    const remove = (index) => {
        onChange(value.filter((_, i) => i !== index));
    };
    const add = () => {
        onChange([...value, '']);
    };
    return (React.createElement(Grid, { item: true, style: { marginTop: 8 }, xs: 12 },
        React.createElement(Typography, { style: {
                alignItems: 'center',
                display: 'flex',
                gap: 4,
                marginBottom: 4
            }, variant: "body2" },
            label,
            info && React.createElement(InfoDot, { info: info })),
        value.map((code, idx) => (React.createElement(Grid, { alignItems: "center", container: true, item: true, 
            // eslint-disable-next-line react/no-array-index-key
            key: idx, spacing: 1, style: { marginBottom: 4 } },
            React.createElement(Grid, { item: true, xs: 8 },
                React.createElement(FormControl, { fullWidth: true, size: "small" },
                    React.createElement(InputLabel, null, "Country"),
                    React.createElement(Select, { onChange: (e) => {
                            update(idx, String(e.target.value));
                        }, value: code },
                        React.createElement(MenuItem, { disabled: true, value: "" },
                            React.createElement("em", null, "Select a country")),
                        COUNTRY_OPTIONS.filter((o) => o.code === code || !value.includes(o.code)).map((o) => (React.createElement(MenuItem, { key: o.code, value: o.code }, o.label)))))),
            React.createElement(Grid, { item: true, xs: 3 },
                React.createElement(Button, { onClick: () => {
                        remove(idx);
                    }, size: "small" }, "Remove"))))),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Button, { onClick: add, size: "small", variant: "outlined" }, "+ Add Country"))));
};
